import { TextField, InputBase } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchcompanyItems from "../../components/searchcompany/searchcompanyItems.jsx";
import { getUsers } from "../../firebase/firebase.js";
import "../../css/homepage.css";
import { toast } from "react-hot-toast";
import SearchUserItem from "./searchUserItem.jsx";

const Searchusers = () => {
  // state
  const [companies, setCompanies] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState();
  const getCom = async () => {
    const not = toast.loading("Loading users...");
    const { companies } = await getUsers();
    setCompanies(companies);
    toast.success("✅Completed!", {
      id: not,
    });
  };
  useEffect(() => {
    getCom();
  }, []);

  useEffect(() => {
    const filteredData = companies?.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    if (filteredData) {
      setData(filteredData);
    }
  }, [searchTerm]);

  return (
    <div className="flex flex-col px-9">
      <div className="py-12">
        <p className="font-bold text-3xl title">Search For a User</p>
      </div>
      <div className="pb-5">
        <InputBase
          placeholder="search"
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-[50%] bg-white rounded-lg border-2 border-[#22f4fa] text-2xl pl-2"
        />
      </div>
      <div className="grid grid-cols-12 justify-start px-5 py-4 text-[13px] text-slate-600">
        <p className="lg:col-span-2 col-span-4">Logo</p>
        <p className="lg:col-span-2 col-span-4">Name</p>
        <p className="lg:col-span-2 col-span-4">address</p>
      </div>
      <div className="">
        {searchTerm === "" ? (
          <>
            {companies?.map((item, i) => (
              <SearchUserItem companies={item} key={i} />
            ))}
          </>
        ) : (
          <>
            {data?.map((item, i) => (
              <SearchUserItem companies={item} key={i} />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default Searchusers;
